import { getColorwayWithTransparency, getSectionProps } from '@/utils/styles';
import { HomepageHeroProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import Media from '../shared/Media/Media';
import { cn } from '@/utils/styles';
import HomepageHeroList from './shared/HomepageHeroList';

const HomepageHeroTwoColumnVariant = ({
  sys,
  sectionName,
  headline,
  copy,
  desktopImage,
  desktopAspectRatio,
  mobileImage,
  mobileAspectRatio,
  color,
  transparentBackground,
}: HomepageHeroProps) => {
  return (
    <div
      {...getSectionProps(
        undefined,
        undefined,
        sectionName,
        cn(getColorwayWithTransparency(color, transparentBackground)),
      )}
      data-testid="homepage-hero-two-column-variant">
      <div className="content-wrapper">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div>
            <div
              className="font-sans text-[40px] leading-[100%] sm:text-heading-xxl md:text-heading-xxxl font-semibold mb-4"
              {...liveUpdateAttrs(sys?.id, 'headline')}>
              {headline && <RichTextHeadline headline={headline} level="h1" />}
            </div>
            <HomepageHeroList sys={sys} copy={copy} listDisplay="block" />
          </div>
          <div>
            <Media
              media={desktopImage}
              mobileMedia={mobileImage}
              aspectRatio={desktopAspectRatio}
              mobileAspectRatio={mobileAspectRatio}
              sizes="(max-width: 750px) 100vw, 600px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageHeroTwoColumnVariant;
